import { render, staticRenderFns } from "./GoogleStats.vue?vue&type=template&id=2a98e5ad&scoped=true&"
import script from "./GoogleStats.vue?vue&type=script&lang=js&"
export * from "./GoogleStats.vue?vue&type=script&lang=js&"
import style0 from "./GoogleStats.vue?vue&type=style&index=0&id=2a98e5ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98e5ad",
  null
  
)

export default component.exports